import { FinancialsDropDown } from './FinancialsDropDown';
import { formatCurrency } from 'utils/helpers';
import { getLegalDocumentUrl } from './legalDocumentUrls';

const financialRows = (offeringData) => [
  {
    id: 'totalAssets',
    label: 'Total Assets',
    mostRecent:
      offeringData?.totalAssetsRecentYear &&
      `${formatCurrency.format(Number.parseFloat(offeringData?.totalAssetsRecentYear))}`,
    prior:
      offeringData?.totalAssetsPriorYear &&
      `${formatCurrency.format(Number.parseFloat(offeringData?.totalAssetsPriorYear))}`,
    display: Boolean(offeringData?.totalAssetsRecentYear || offeringData?.totalAssetsPriorYear),
  },
  {
    id: 'cash',
    label: 'Cash & Cash Equivalents',
    mostRecent:
      offeringData?.cashAndCashEquivalentsRecentYear &&
      `${formatCurrency.format(parseFloat(offeringData?.cashAndCashEquivalentsRecentYear))}`,
    prior:
      offeringData?.cashAndCashEquivalentsPriorYear &&
      `${formatCurrency.format(parseFloat(offeringData?.cashAndCashEquivalentsPriorYear))}`,
    display: Boolean(
      offeringData?.cashAndCashEquivalentsRecentYear ||
      offeringData?.cashAndCashEquivalentsPriorYear,
    ),
  },
  {
    id: 'accountsReceivable',
    label: 'Accounts Receivable',
    mostRecent:
      offeringData?.accountsReceivableRecentYear &&
      `${formatCurrency.format(parseFloat(offeringData?.accountsReceivableRecentYear))}`,
    prior:
      offeringData?.accountsReceivablePriorYear &&
      `${formatCurrency.format(parseFloat(offeringData?.accountsReceivablePriorYear))}`,
    display: Boolean(
      offeringData?.accountsReceivableRecentYear || offeringData?.accountsReceivablePriorYear,
    ),
  },
  {
    id: 'shortTermDebt',
    label: 'Short-Term Debt',
    mostRecent:
      offeringData?.shortTermDebtRecentYear &&
      `${formatCurrency.format(parseFloat(offeringData?.shortTermDebtRecentYear))}`,
    prior:
      offeringData?.shortTermDebtPriorYear &&
      `${formatCurrency.format(parseFloat(offeringData?.shortTermDebtPriorYear))}`,
    display: Boolean(offeringData?.shortTermDebtRecentYear || offeringData?.shortTermDebtPriorYear),
  },
  {
    id: 'longTermDebt',
    label: 'Long-Term Debt',
    mostRecent:
      offeringData?.longTermDebtRecentYear &&
      `${formatCurrency.format(parseFloat(offeringData?.longTermDebtRecentYear))}`,
    prior:
      offeringData?.longTermDebtPriorYear &&
      `${formatCurrency.format(parseFloat(offeringData?.longTermDebtPriorYear))}`,
    display: Boolean(offeringData?.longTermDebtRecentYear || offeringData?.longTermDebtPriorYear),
  },
  {
    id: 'revenue',
    label: 'Revenue & Sales',
    mostRecent:
      offeringData?.revenueAndSalesRecentYear &&
      `${formatCurrency.format(parseFloat(offeringData?.revenueAndSalesRecentYear))}`,
    prior:
      offeringData?.revenueAndSalesPriorYear &&
      `${formatCurrency.format(parseFloat(offeringData?.revenueAndSalesPriorYear))}`,
    display: Boolean(
      offeringData?.revenueAndSalesRecentYear || offeringData?.revenueAndSalesPriorYear,
    ),
  },
  {
    id: 'costs',
    label: 'Costs of Goods Sold',
    mostRecent:
      offeringData?.costOfGoodsSoldRecentYear &&
      `${formatCurrency.format(parseFloat(offeringData?.costOfGoodsSoldRecentYear))}`,
    prior:
      offeringData?.costOfGoodsSoldPriorYear &&
      `${formatCurrency.format(parseFloat(offeringData?.costOfGoodsSoldPriorYear))}`,
    display: Boolean(
      offeringData?.costOfGoodsSoldRecentYear || offeringData?.costOfGoodsSoldPriorYear,
    ),
  },
  {
    id: 'taxes',
    label: 'Taxes Paid',
    mostRecent:
      offeringData?.taxesPaidRecentYear &&
      `${formatCurrency.format(parseFloat(offeringData?.taxesPaidRecentYear))}`,
    prior:
      offeringData?.taxesPaidPriorYear &&
      `${formatCurrency.format(parseFloat(offeringData?.taxesPaidPriorYear))}`,
    display: Boolean(offeringData?.taxesPaidRecentYear || offeringData?.taxesPaidPriorYear),
  },
  {
    id: 'netIncome',
    label: 'Net Income',
    mostRecent:
      offeringData?.netIncomeRecentYear &&
      `${formatCurrency.format(parseFloat(offeringData?.netIncomeRecentYear))}`,
    prior:
      offeringData?.netIncomePriorYear &&
      `${formatCurrency.format(parseFloat(offeringData?.netIncomePriorYear))}`,
    display: Boolean(offeringData?.netIncomeRecentYear || offeringData?.netIncomePriorYear),
  },
];

export const termsRisks = (offeringData) => {
  const secUrl = getLegalDocumentUrl(offeringData?.secUrl);
  const offeringCircularUrl = getLegalDocumentUrl(offeringData?.offeringCircularUrl, {
    offeringSlug: offeringData?.slug,
    rejectOfferingSelfLink: true,
  });
  const offeringDetailsUrl = getLegalDocumentUrl(offeringData?.offeringDetailsUrl);
  const associatedRisksUrl = getLegalDocumentUrl(offeringData?.associatedRisksUrl);

  return [
    {
      id: 'secRecentFiling',
      title: 'SEC Recent Filing',
      url: secUrl,
      detail: '',
      display: Boolean(secUrl),
    },
    {
      id: 'offeringCircular',
      title: 'Offering Circular',
      url: offeringCircularUrl,
      detail: '',
      display: Boolean(offeringCircularUrl),
    },
    {
      id: 'offeringMemorandum',
      title: 'Offering Memorandum',
      url: offeringDetailsUrl,
      detail: '',
      display: Boolean(offeringDetailsUrl),
    },
    {
      id: 'risksRelatedToTheOffering',
      title: 'Offering Related Risks',
      url: associatedRisksUrl,
      detail: '',
      display: Boolean(associatedRisksUrl),
    },
    {
      id: 'financials',
      title: 'Financials',
      detail: <FinancialsDropDown rows={financialRows(offeringData)} />,
      display:
        financialRows(offeringData)?.some((row) => row?.display === true) &&
        offeringData?.regulationType !== 'Reg A+' &&
        offeringData?.regulationType !== 'title4',
    },
    {
      id: 'risks',
      title: 'Risks',
      detail: (
        <>
          A crowdfunding investment involves risk. You should not invest any funds in this offering
          unless you can afford to lose your entire investment. In making an investment decision,
          investors must rely on their own examination of the issuer and the terms of the offering,
          including the merits and risks involved. These securities have not been recommended or
          approved by any federal or state securities commission or regulatory authority.
          Furthermore, these authorities have not passed upon the accuracy or adequacy of this
          document. The U.S. Securities and Exchange Commission does not pass upon the merits of any
          securities offered or the terms of the offering, nor does it pass upon the accuracy or
          completeness of any offering document or literature. These securities are offered under an
          exemption from registration; however, the U.S. Securities and Exchange Commission has not
          made an independent determination that these securities are exempt from registration.
        </>
      ),
      display: true,
    },
  ];
};
